export function normalizeChoice(choice) {
  if (typeof choice === "string" || typeof choice === "number") return choice;
  if (choice && typeof choice === "object") {
    const value = choice.value ?? choice.text ?? "";
    const text = choice.text ?? String(value);
    return { value, text };
  }
  return choice;
}

export function normalizeText(value) {
  if (value == null) return value;
  if (typeof value === "string" || typeof value === "number") return value;
  if (typeof value === "object") {
    return value.default ?? value.en ?? Object.values(value)[0] ?? "";
  }
  return value;
}

export function sanitizeSurveyFormJson(formJson) {
  if (!formJson || typeof formJson !== "object") return formJson;

  const walkElements = (elements = []) => {
    elements.forEach((el) => {
      if (el.title !== undefined) el.title = normalizeText(el.title);
      if (el.description !== undefined) el.description = normalizeText(el.description);
      if (Array.isArray(el.choices)) {
        el.choices = el.choices.map(normalizeChoice);
      }
      if (Array.isArray(el.columns)) {
        el.columns.forEach((col) => {
          if (col.title !== undefined) col.title = normalizeText(col.title);
          if (Array.isArray(col.choices)) col.choices = col.choices.map(normalizeChoice);
        });
      }
      if (Array.isArray(el.elements)) {
        walkElements(el.elements);
      }
    });
  };

  if (formJson.title !== undefined) formJson.title = normalizeText(formJson.title);
  if (formJson.description !== undefined) formJson.description = normalizeText(formJson.description);

  (formJson.pages || []).forEach((page) => {
    if (page.title !== undefined) page.title = normalizeText(page.title);
    walkElements(page.elements);
  });

  return formJson;
}
